import ReportItemReceive from "../../../../components/@reports/warehouse/ReportItemReceive";

import { ReportContextProvider } from "../../../../context/ReportContext";

import { reportScopes, reportTypes } from "../../../../hooks/api/useReports";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

import { validationSchema, initialValues, advancedValidationSchema, advancedInitialValues } from "../../../../schema/reports/warehouse/itemReceiveSchema"

export default function ItemReceiveReport() {

    let routeType = routeTypes.admin

    return (
        <ReportContextProvider
            routeType={routeType}
            reportScope={reportScopes.warehouse}
            reportType={reportTypes.warehouse.itemReceive.id}
            validationSchema={validationSchema}
            advancedValidationSchema={advancedValidationSchema}
            initialValues={initialValues}
            advancedInitialValues={advancedInitialValues}
        >
            <ReportItemReceive
                routeType={routeType}
            />
        </ReportContextProvider>
    )
}       